import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { RadioButtons } from '@grandvisionhq/forms';
import { H2, H3 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../context/CheckoutSettings/context.js';
import { useNearestStore } from '../../../modules/ServiceStore/hooks/use-nearest-store.js';
import '@grandvisionhq/common';
import '@grandvisionhq/icons';
import 'throttle-debounce';
import '../../../slots/forms/form-context.js';
import '../../../slots/summaries/summary-context.js';
import '../../../slots/summaries/types.js';
import '../../../state.js';
import '../../../StepShipping/selectors.js';
import 'lodash/isEmpty';
import '@grandvisionhq/utils';
import '../../../mappers/errors-mapping.js';
import '../../../utils/get-customer-details-payload.js';
import '../../../models/cart/cart-state.js';
import '../../../models/checkout/checkout-step-error-type.js';
import '../../../models/checkout-settings.js';
import '../../../models/step-shipping/shipping-methods.js';
import '../../../models/shared.js';
import 'history';
import '../../../utils/has-cart-errors.js';
import { EditableLoyaltyPointsSummary } from '../../../StepOverview/EditableSummaries/EditableLoyaltyPointsSummary.js';
import { CustomerType } from '../../../types.js';
import { useLoggedInCheckout } from '../../context/context.js';
import '@grandvisionhq/lib-utils-w3c';
import { useUserStateConfig } from '../../hooks/useUserStateConfig.js';
import { AddressSummary } from './Summary/AddressSummary.js';
import { CompanySummary } from './Summary/CompanySummary.js';
import { ContactDetailsSummary } from './Summary/ContactDetailsSummary.js';
import { InvoiceSummary } from './Summary/InvoiceSummary.js';
import { ServiceStore } from './Summary/ServiceStore/ServiceStore.js';

const UserDetails = ()=>{
    var ref1;
    const { billingAddress , contactDetails , globalStoreId , areUserDetailsLoading , error , isUserLoggedIn ,  } = useUserStateConfig();
    const { userDetailsState , setUserDetailsState , isCompanyOrder , isPickupOrder , shippingState , setShippingState , setIsCompany , isOrderDetailsValid , isAddressesEqual , isFailedToFetchUserData , setIsFailedToFetchUserData , setIsUserLoggedIn ,  } = useLoggedInCheckout();
    const { getLabel  } = useIntl();
    const { features , serviceStore  } = useCheckoutSettings();
    const { cart  } = Context.useCart();
    const cartServiceStoreId = React.useMemo(()=>{
        var ref;
        return cart === null || cart === void 0 ? void 0 : (ref = cart.serviceStore) === null || ref === void 0 ? void 0 : ref.globalStoreId;
    }, [
        cart === null || cart === void 0 ? void 0 : (ref1 = cart.serviceStore) === null || ref1 === void 0 ? void 0 : ref1.globalStoreId
    ]);
    const isServiceStoreValid = React.useMemo(()=>{
        return !(features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) || shippingState.serviceStore || (serviceStore === null || serviceStore === void 0 ? void 0 : serviceStore.isOptional);
    }, [
        features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled,
        serviceStore === null || serviceStore === void 0 ? void 0 : serviceStore.isOptional,
        shippingState.serviceStore
    ]);
    const labels = React.useMemo(()=>{
        return {
            customerType: {
                private: getLabel('checkout.customerType.private'),
                company: getLabel('checkout.customerType.company')
            },
            serviceStore: {
                title: `${getLabel('checkout.serviceStore.title')} ${(features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) && (serviceStore === null || serviceStore === void 0 ? void 0 : serviceStore.isOptional) ? `(${getLabel('checkout.form.field.optional').toLowerCase()})` : ''}`
            }
        };
    }, [
        features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled,
        getLabel,
        serviceStore === null || serviceStore === void 0 ? void 0 : serviceStore.isOptional
    ]);
    // Merge contact details in local storage state with contact details from my-account
    const mergeUserContactDetailsState = (localState, apiDataState)=>{
        return swcHelpers.objectSpread({}, localState, Object.fromEntries(Object.entries(apiDataState).filter(([key, value])=>!localState[key] && value
        )));
    };
    const syncUserDetailsState = React.useCallback(()=>{
        const isLocalBillingAddressEmpty = !(userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.billingAddress) || Object.values(userDetailsState.billingAddress).every((value)=>value == null || value === ''
        );
        const isContactDetailsEmpty = !(userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.contactDetails) || Object.values(userDetailsState.contactDetails).every((value)=>value == null || value === ''
        );
        setUserDetailsState(swcHelpers.objectSpread({}, userDetailsState, isLocalBillingAddressEmpty ? {
            billingAddress
        } : {}, isContactDetailsEmpty ? {
            contactDetails
        } : (userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.contactDetails) && contactDetails ? {
            contactDetails: mergeUserContactDetailsState(userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.contactDetails, contactDetails)
        } : {}, !userDetailsState.deliveryAddress ? {
            deliveryAddress: undefined
        } : {}, !(userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.invoice) ? {
            invoice: undefined
        } : {}, !(userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.company) ? {
            company: undefined
        } : {}));
        if (!userDetailsState.deliveryAddress) {
            setShippingState(swcHelpers.objectSpread({}, shippingState, {
                isAddressesEqual: true
            }));
        }
    }, [
        billingAddress,
        contactDetails,
        setShippingState,
        setUserDetailsState,
        shippingState,
        userDetailsState, 
    ]);
    const saveFormDetails = React.useCallback((formData)=>{
        if (!formData) return;
        setUserDetailsState(swcHelpers.objectSpread({}, userDetailsState, formData));
    }, [
        setUserDetailsState,
        userDetailsState
    ]);
    const handleAddressEqual = React.useCallback((value)=>{
        setShippingState(swcHelpers.objectSpread({}, shippingState, {
            isAddressesEqual: value
        }));
    }, [
        setShippingState,
        shippingState
    ]);
    const handleFocusForError = ()=>{
        if (typeof window !== 'undefined') {
            const topErrorField = window.document.querySelector('div[role="alert"].alert-m-default');
            if (topErrorField) {
                topErrorField.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
                topErrorField === null || topErrorField === void 0 ? void 0 : topErrorField.focus();
            }
        }
    };
    const nearestStoreQuery = React.useMemo(()=>{
        if (billingAddress) {
            const postalCode = (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalCode) || '';
            const streetName = (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.streetName) || '';
            const streetNumber = (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.streetNumber) || '';
            const city = (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.city) || '';
            return `${postalCode} ${streetName} ${streetNumber} ${city}`.replace(/\s{2,}/g, ' ').trim();
        }
        return '';
    }, [
        billingAddress
    ]);
    const [storeId, isLoadingNearestStore] = useNearestStore(nearestStoreQuery, !globalStoreId && !cartServiceStoreId && !!(serviceStore === null || serviceStore === void 0 ? void 0 : serviceStore.preselectFromShippingData));
    React.useEffect(()=>{
        if (!areUserDetailsLoading) {
            syncUserDetailsState();
        }
        if (!isOrderDetailsValid) {
            handleFocusForError();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        areUserDetailsLoading,
        isOrderDetailsValid
    ]);
    const handleUserDataFetchError = React.useCallback(()=>{
        if (isFailedToFetchUserData) return;
        if (!isFailedToFetchUserData) {
            setIsFailedToFetchUserData(true);
        }
    }, [
        isFailedToFetchUserData,
        setIsFailedToFetchUserData
    ]);
    const isServiceStoreFeatureEnabled = React.useMemo(()=>{
        return (features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) && !isPickupOrder && !isLoadingNearestStore;
    }, [
        features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled,
        isPickupOrder,
        isLoadingNearestStore
    ]);
    React.useEffect(()=>{
        if (error) {
            handleUserDataFetchError();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        error
    ]);
    React.useEffect(()=>{
        if (isUserLoggedIn) {
            setIsUserLoggedIn(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isUserLoggedIn
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(H2, {
        variant: "heading-small"
    }, getLabel('checkout.instant.userDetails.heading')), /*#__PURE__*/ React.createElement(H3, {
        variant: "text-body"
    }, getLabel('checkout.instant.userDetails.subheading')), Boolean(features === null || features === void 0 ? void 0 : features.isCompanyEnabled) && /*#__PURE__*/ React.createElement(RadioButtons, {
        scope: "orderType",
        alignment: "horizontal",
        onChange: (radioState)=>setIsCompany(radioState.value === CustomerType.Company)
        ,
        initialValue: isCompanyOrder ? CustomerType.Company : CustomerType.Private,
        items: [
            {
                value: CustomerType.Private,
                label: labels.customerType.private
            },
            {
                value: CustomerType.Company,
                label: labels.customerType.company
            }, 
        ]
    }), /*#__PURE__*/ React.createElement(AddressSummary, {
        address: userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.billingAddress,
        deliveryAddress: userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.deliveryAddress,
        isPickupOrder: isPickupOrder,
        onSubmit: saveFormDetails,
        isOrderDetailsValid: isOrderDetailsValid,
        isAddressesEqual: isAddressesEqual,
        handleAddressEqual: handleAddressEqual
    }), /*#__PURE__*/ React.createElement(ContactDetailsSummary, {
        onSubmit: saveFormDetails,
        contactDetails: userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.contactDetails,
        isOrderDetailsValid: isOrderDetailsValid,
        isFailedToFetchUserData: isFailedToFetchUserData
    }), !isCompanyOrder ? /*#__PURE__*/ React.createElement(InvoiceSummary, {
        onSubmit: saveFormDetails,
        invoiceDetails: userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.invoice,
        isOrderDetailsValid: isOrderDetailsValid
    }) : /*#__PURE__*/ React.createElement(CompanySummary, {
        onSubmit: saveFormDetails,
        companyDetails: userDetailsState === null || userDetailsState === void 0 ? void 0 : userDetailsState.company,
        isOrderDetailsValid: isOrderDetailsValid
    }), /*#__PURE__*/ React.createElement(EditableLoyaltyPointsSummary, null), isServiceStoreFeatureEnabled && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ServiceStore, {
        globalStoreId: globalStoreId || storeId,
        title: labels.serviceStore.title,
        isServiceStoreValid: Boolean(isServiceStoreValid),
        isOrderDetailsValid: isOrderDetailsValid
    })));
};

export { UserDetails };
//# sourceMappingURL=UserDetails.js.map
